<doc>
  @desc:   布局 - 登录组件
  @author:  
</doc>
<template>
  <div id="loginComponent">
    <van-popup v-model="show" class="van-popup-m"
    closeable
    close-icon="close"
    @closed="loginPopClose" :position="screenWidth>767?'center':'bottom'" get-container="#app">
      <div class="comoment-pop-wrapper" v-if="show">
        <!-- <div class="loginBox flex flex-align-center" v-if="step.length==0">
          <div class="login-left">
            <div class="login-logo"></div>
            <div class="login-intro">
              <h4 class="login-intro-title">{{ langConfig.login[langConfig.curLang]['SIGN_UP_MORE'] }}</h4>
              <div class="login-intro-item flex flex-align-center">
                <em><i class="icon-font icon-login-fav"></i></em>
                <span>{{ langConfig.login[langConfig.curLang]['FOLLOW_MATCHES'] }}</span>
              </div>
              <div class="login-intro-item flex flex-align-center">
                <em><i class="icon-font icon-login-news"></i></em>
                <span>{{ langConfig.login[langConfig.curLang]['VIEW_NEWS'] }}</span>
              </div>
              <div class="login-intro-item flex flex-align-center">
                <em><i class="icon-font icon-login-sync"></i></em>
                <span>{{ langConfig.login[langConfig.curLang]['SYNC_DEVICES'] }}</span>
              </div>
            </div>
          </div>
          <div class="login-left-mobile">
            <div class="login-left-bg">
              <div class="login-logo"></div>
              <div class="login-intro">
                <h4 class="login-intro-title">{{ langConfig.login[langConfig.curLang]['SIGN_UP_MORE'] }}</h4>
                <div class="login-intro-icon flex flex-pack-center">
                  <em><i class="icon-font icon-login-fav"></i></em>
                  <em><i class="icon-font icon-login-news"></i></em>
                  <em><i class="icon-font icon-login-sync"></i></em>
                </div>
                <ul class="login-intro-list">
                  <li><i></i>{{ langConfig.login[langConfig.curLang]['FOLLOW_MATCHES'] }}</li>
                  <li><i></i>{{ langConfig.login[langConfig.curLang]['VIEW_NEWS'] }}</li>
                  <li><i></i>{{ langConfig.login[langConfig.curLang]['SYNC_DEVICES'] }}</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="login-right">
            <div class="login-form">
              <div class="login-form-item flex flex-align-center flex-pack-center" @click="loginWithGoogle()">
                <i><img src="~@/assets/images/google-icon.svg" /></i>
                <span>Continue with Google</span>
              </div>
              <div class="login-form-item flex flex-align-center flex-pack-center">
                <i><img src="~@/assets/images/face-icon.svg" /></i>
                <span>Continue with Facebook</span>
              </div>
              <div class="login-form-item flex flex-align-center flex-pack-center" @click="loginWithApple()">
                <i><img src="~@/assets/images/apple-icon.svg" /></i>
                <span>Continue with Apple</span>
              </div>
              <div class="login-form-item flex flex-align-center flex-pack-center" @click="loginWithEmail()">
                <i><img src="~@/assets/images/mail-icon.svg" /></i>
                <span>{{ langConfig.login[langConfig.curLang]['CONTINUE_EMAIL'] }}</span>
              </div>
              <div class="login-form-tips" v-html="langConfig.login[langConfig.curLang]['LOGIN_TIPS']"></div>
            </div>
          </div>
        </div> -->
        <div class="login-step flex flex-v flex-pack-center" v-if="step.length>0">

          <div class="step-back flex flex-align-center" @click="stepBack" v-if="[2,5].includes(step[step.length-1])">
            <i class="icon-font icon-arr step-back-arr"></i>
            <span>{{ langConfig.login[langConfig.curLang]['BACK'] }}</span>
          </div>
          
          <div class="flex flex-v flex-pack-center" :class="[step.length == 4 ? 'login-step-2' : 'login-step-1']">

            <div class="step-rest-success" v-if="step[step.length-1] == 8"><img src="~@/assets/images/success-icon.svg" /></div>

            <h3 class="step-title" v-if="step[step.length-1] == 1">{{ langConfig.login[langConfig.curLang]['LOGIN_ACCOUNT'] }}</h3>
            <h3 class="step-title" v-if="step[step.length-1] == 2">{{ langConfig.login[langConfig.curLang]['CREATE_ACCOUNT'] }}</h3>
            <h3 class="step-title" v-if="step[step.length-1] == 3">{{ langConfig.login[langConfig.curLang]['REGISTRATION'] }}</h3>
            <h3 class="step-title mb8" v-if="step[step.length-1] == 4">{{ langConfig.login[langConfig.curLang]['LOGIN_ACCOUNT'] }}</h3>
            <h3 class="step-title mb8" v-if="step[step.length-1] == 5">{{ langConfig.login[langConfig.curLang]['FORGOT'] }}</h3>
            <h3 class="step-title" v-if="step[step.length-1] == 6">{{ langConfig.login[langConfig.curLang]['PASSWORD_RESET'] }}</h3>
            <h3 class="step-title" v-if="step[step.length-1] == 7">{{ langConfig.login[langConfig.curLang]['RESET'] }}</h3>
            <h3 class="step-title mb0" v-if="step[step.length-1] == 8">{{ langConfig.login[langConfig.curLang]['RESET_SUCCESS'] }}</h3>
            <h3 class="step-title" v-if="step[step.length-1] == 9">{{ langConfig.login[langConfig.curLang]['ACCOUNT_NOT_ACTIVE'] }}</h3>
            <h3 class="step-title" v-if="step[step.length-1] == 11">{{ langConfig.login[langConfig.curLang]['ACTIVE_FAIL'] }}</h3>
            <h3 class="step-title" v-if="step[step.length-1] == 12">{{ langConfig.login[langConfig.curLang]['RESET_PASSWORD_FAIL'] }}</h3>


            <p class="step-tips" v-if="step[step.length-1] == 4">{{ langConfig.login[langConfig.curLang]['ACCOUNT_SUCCESS'] }}</p>
            <p class="step-tips" v-if="step[step.length-1] == 5">{{ langConfig.login[langConfig.curLang]['NEW_PASSWORD'] }}</p>
            <p class="step-tips" v-if="step[step.length-1] == 9" v-html="langConfig.login[langConfig.curLang]['ACCOUNT_NOT_ACTIVE_TIPS'].replace('?1', this.loginForm.email)"></p>
            <p class="step-tips" v-if="step[step.length-1] == 11">{{ langConfig.login[langConfig.curLang]['LINK_EXPIRED'] }}</p>
            <p class="step-tips" v-if="step[step.length-1] == 12">{{ langConfig.login[langConfig.curLang]['PASSWORD_LINK_EXPIRED'] }}</p>


            <van-form ref="form" @submit="onSubmit" v-if="![3,6,8,10,11,12].includes(step[step.length-1])">
              <div class="step-input-item" v-if="![7,9].includes(step[step.length-1])">
                <van-field
                  v-model="loginForm.email"
                  name="email"
                  :placeholder="langConfig.login[langConfig.curLang]['PLACEHOLDER_EMAIL']"
                  :error-message="errorMessageEmail"
                  @input="validatroFn(loginForm.email, 'email')"
                />
              </div>
              <div class="step-input-item" v-if="![5,9].includes(step[step.length-1]) || step[step.length-1] == 7">
                <van-field
                  v-model="loginForm.password"
                  name="password"
                  :placeholder="langConfig.login[langConfig.curLang]['PLACEHOLDER_PWD']"
                  :right-icon="passwordState ? 'eye' : 'closed-eye'"
                  :type="!passwordState ? 'password' : 'text'"
                  @click-right-icon="passwordState = !passwordState"
                  :error-message="errorMessagePwd"
                  @input="validatroFn(loginForm.password, 'pwd')"
                />
              </div>
              <div class="step-input-item" v-if="step[step.length-1] == 7">
                <van-field
                  v-model="loginForm.password2"
                  name="password2"
                  :placeholder="langConfig.login[langConfig.curLang]['PLACEHOLDER_PWD2']"
                  :right-icon="passwordState2 ? 'eye' : 'closed-eye'"
                  :type="!passwordState2 ? 'password' : 'text'"
                  @click-right-icon="passwordState2 = !passwordState2"
                  :error-message="errorMessagePwd2"
                  @input="validatroFn(loginForm.password2, 'pwd2')"
                />
              </div>
              <!-- <div class="step-captcha flex flex-align-center flex-pack-center" v-if="reCaptchaFlag">
                <reCaptcha @getValidateCode='getValidateCode' v-model="loginForm.validateCode"></reCaptcha>
              </div> -->
              <div class="step-code flex" v-if="[1,2,4,5,9].includes(step[step.length-1])">
                <div class="step-code-input">
                  <van-field
                    v-model="loginForm.captcha"
                    name="captcha"
                    :placeholder="langConfig.login[langConfig.curLang]['PLACEHOLDER_CODE']"
                    @input="validatroFn(loginForm.captcha, 'captcha')"
                  />
                </div>
                <div class="step-code-img">
                  <img :src="captchaSrc" @click="reloadCodeImgFn()" />
                </div>
              </div>
              <div class="step-btn">
                <van-button :disabled="disabled" round block type="info" native-type="submit">
                  <span v-if="![2,5,6,7,9].includes(step[step.length-1])">{{ langConfig.login[langConfig.curLang]['LOGIN'] }}</span>
                  <span v-if="step[step.length-1] == 2">{{ langConfig.login[langConfig.curLang]['SIGNUP'] }}</span>
                  <span v-if="step[step.length-1] == 5 || step[step.length-1] == 6">{{ langConfig.login[langConfig.curLang]['SEND'] }}</span>
                  <span v-if="step[step.length-1] == 7">{{ langConfig.login[langConfig.curLang]['SAVE'] }}</span>
                  <span v-if="step[step.length-1] == 9">{{ langConfig.login[langConfig.curLang]['SEND_AGAIN'] }}</span>
                </van-button>
              </div>
            </van-form>

            <div class="sign-success-btn" @click="toLogInFail()" v-if="[11].includes(step[step.length-1])">{{ langConfig.login[langConfig.curLang]['LOGIN'] }}</div>
            <div class="sign-success-btn" @click="toForgotFail()" v-if="[12].includes(step[step.length-1])">{{ langConfig.login[langConfig.curLang]['RETRIEVE_PASSWORD'] }}</div>
            <div class="sign-close-btn" @click="loginPopClose()" v-if="[9,11,12].includes(step[step.length-1])">{{ langConfig.login[langConfig.curLang]['CLOSE'] }}</div>

            <template v-if="step[step.length-1] < 3">
              <div class="step-forgetPwd" v-if="step[step.length-1] == 1" @click="toForgot">{{ langConfig.login[langConfig.curLang]['FORGOT'] }}</div>
              <div class="step-singup-tips" v-if="step[step.length-1] == 2" v-html="langConfig.login[langConfig.curLang]['SINGUP_TIPS']"></div>
              <div class="step-up-btn" v-if="step[step.length-1] == 1" @click="SignUpBtn($event)" v-html="langConfig.login[langConfig.curLang]['EMAIL_REGISTER_TIPS']"></div>
              <div class="step-up-btn" v-if="step[step.length-1] == 2" @click="LogInBtn($event)" v-html="langConfig.login[langConfig.curLang]['EMAIL_LOGIN_TIPS']"></div>
            </template>

            <div class="sign-success-tips" v-if="step[step.length-1] == 3" v-html="langConfig.login[langConfig.curLang]['REGISTER_VER'].replace('?1', this.loginForm.email)"></div>
            <div class="sign-success-tips" v-if="step[step.length-1] == 10" v-html="langConfig.login[langConfig.curLang]['REGISTER_AGAIN_TIPS'].replace('?1', this.loginForm.email)"></div>
            <div class="sign-success-tips" v-if="step[step.length-1] == 6" v-html="langConfig.login[langConfig.curLang]['PASSWORD_VER'].replace('?1', this.loginForm.email)"></div>

            <div class="sign-success-btn" @click="loginPopClose()" v-if="[3,6,10].includes(step[step.length-1])">{{ langConfig.login[langConfig.curLang]['GOT_IT'] }}</div>
          </div>

          <div class="step-resend-tips" v-if="[9].includes(step[step.length-1])" v-html="langConfig.login[langConfig.curLang]['RESEND_TIPS']"></div>

          <!-- <div class="login-step-1 flex flex-v flex-pack-center" v-if="step[step.length-1] == 2">
            <h3 class="step-title">Create a new account</h3>
            <van-form ref="signForm" @submit="onSignUpSubmit">
              <div class="step-input-item">
                <van-field
                  v-model="email"
                  name="email"
                  placeholder="Email"
                  :rules="pattern.emailrules"
                  v-if="login.loginShow"
                />
              </div>
              <div class="step-input-item">
                <van-field
                  v-model="password"
                  name="password"
                  placeholder="Password"
                  :right-icon="passwordState ? 'eye' : 'closed-eye'"
                  :type="!passwordState ? 'password' : 'text'"
                  @click-right-icon="passwordState = !passwordState"
                  :rules="pattern.pwdrules"
                  v-if="login.loginShow"
                />
              </div>
              <div class="step-btn">
                <van-button :disabled="disabled" round block type="info" native-type="submit">Sign up</van-button>
              </div>
            </van-form>
            <div class="step-up-btn">If you have an account, please <span @click="toLogIn">log in</span></div>
          </div>

          <div class="login-step-1 flex flex-v flex-pack-center" v-if="step[step.length-1] == 3">
            <h3 class="step-title">Registration complete!</h3>
            <div class="sign-success-tips">We have sent a registration verification email to your registered email address <span>[{{ this.email }}]</span>.<br />Please check your mailbox and confirm your registration, thank you!</div>
            <div class="sign-success-btn" @click="loginPopClose">I got it</div>
          </div>

          <div class="login-step-2 flex flex-v flex-pack-center" v-if="step[step.length-1] == 4">
            <h3 class="step-title mb8">Log in to an existing account</h3>
            <p class="step-tips">Your account has been successfully activated and you can now log in.</p>
            <van-form ref="loginForm" @submit="onLoginSubmit">
              <div class="step-input-item">
                <van-field
                  v-model="email"
                  name="email"
                  placeholder="Email"
                  :rules="pattern.emailrules"
                  v-if="login.loginShow"
                />
              </div>
              <div class="step-input-item">
                <van-field
                  v-model="password"
                  name="password"
                  placeholder="Password"
                  :right-icon="passwordState ? 'eye' : 'closed-eye'"
                  :type="!passwordState ? 'password' : 'text'"
                  @click-right-icon="passwordState = !passwordState"
                  :rules="pattern.pwdrules"
                  v-if="login.loginShow"
                />
              </div>
              <div class="step-btn">
                <van-button :disabled="disabled" round block type="info" native-type="submit">Log in</van-button>
              </div>
            </van-form>
            <div class="step-forgetPwd">Forget password?</div>
            <div class="step-up-btn">If you don't have an account, please <span @click="toSingUp">sign up</span></div>
          </div> -->
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
  import { Toast } from 'vant';
  import { getEmailLogin, getEmailSignUp, getForgotPwd, getResetPwd, getThirdLogin, getAppleLogin } from '@/api/api';
  import host from '@/utils/host';
  import http_env from '@/utils/http_env';
  import reCaptcha from '@/components/reCaptcha'

  export default {
    props: ['loginShow'],

    components: {
      reCaptcha
    },

    data() {
      return {
        login:{
          loginShow: false,
          loginInfoShow: false
        },
        show: false,
        step:[1], // 1-登录界面, 2-注册界面, 3-注册成功, 4-注册激活登录, 5-修改密码, 6-修改成功, 7-重设密码, 8-重设密码成功, 9-账户未激活, 10-重新发送成功, 11-激活失败, 12-重设密码激活失败
        token: '',
        resetToken: '', // 重设密码token
        disabled: true, // 提交是否禁用
        passwordState: false,
        passwordState2: false,
        reCaptchaFlag: true, //重置人机认证
        errorMessageEmail: '',
        errorMessagePwd: '',
        errorMessagePwd2: '',
        errorFlag: true,
        emailRxp: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        pwdRxp: /[a-zA-Z0-9]{6,}/,
        //pwdRxp: /^(?!([a-zA-Z]+|\d+)$)[a-zA-Z\d]{6,}$/,
        pattern:{
          emailrules:[
            {
              required: true, 
              message: 'Email format is incorrect, please re-enter', 
              trigger: 'onBlur'
            }
          ],
          pwdrules:[
            {
              required: true,
              message: 'Please enter at least 6 digits',
              trigger: 'onBlur'
            }
          ]
        },
        screenWidth:2000,

        loginForm: {
          email: '',
          password: '',
          password2: '',
          validateCode: '',
          captcha: '',
        },

        captchaSrc: '', // 验证图片地址
      };
    },

    mounted() {
      if(typeof(window) != 'undefined'){
        this.captchaSrc = this.codeImgFn();
        this.backPop();
        this.screenWidth = window.innerWidth;
        window.addEventListener('resize', this.handleResize);
      }
    },
    beforeDestroy() {
      if(typeof window!='undefined'){
        window.removeEventListener('resize', this.handleResize);
      }
    },

    methods: {
      getValidateCode(value) {
        this.loginForm.validateCode = value;
        this.isSubmit();
      },
      // google登录
      loginWithGoogle() {
        const clientId = '329504960716-dibco64ktqehcgvq90el3rrfl5ic2gt3.apps.googleusercontent.com';
        //const redirectUri = host() + 'user/version/1_0/login/oauth/callback';
        const redirectUri = 'https://www.'+ http_env() +'.vipgoal.com/oauth/googleCallback';
        const scope = 'https://www.googleapis.com/auth/userinfo.profile%20https://www.googleapis.com/auth/userinfo.email';
        const response_type = 'code';

        const authUrl = `https://accounts.google.com/o/oauth2/auth?client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scope}&response_type=${response_type}`;

        window.open(authUrl, '_blank');
      },
      // apple登录
      loginWithApple() {
        const clientId = 'weblogin.athletic.vipgoal';
        const redirectUri = host() + 'user/version/1_0/login/oauth/apple_callback';
        const scope = 'name email'; // 请求的授权范围

        const authUrl = `https://appleid.apple.com/auth/authorize?client_id=${clientId}&redirect_uri=${redirectUri}&response_type=code&scope=${scope}&response_mode=form_post`;

        window.open(authUrl, '_blank');
      },
      // 邮箱登录
      loginWithEmail(){
        this.step.push(1);
      },

      // 关闭登录弹窗
      loginPopClose(){
        this.clearInput();
        this.reCaptchaFlag = true;
        this.step = [1];
        this.show = false;
        this.login.loginShow = false;
        this.$emit('onChangePop', this.login);

        if(this.common.GetQueryString('resetToken') != 'undefined' || this.common.GetQueryString('type') != 'undefined'){// 重设密码,刷新页面
            location.href = location.href.split('?')[0];
            location.reload();
          }
      },

      // 返回操作
      stepBack(){
        let _step = this.step;
        let _len = this.step.length-1;

        if(_step.length > 0){
          _step.pop();

          this.step = _step;
        }
        this.clearInput();
        this.$refs.form.resetValidation();
        setTimeout(()=>{
          this.reCaptchaFlag = true;
        }, 50);
      },

      // 输入框验证
      validatroFn(val, type){
        
        if (type == 'email') {
          let _reg = this.emailRxp;
          if(_reg.test(val)){
            this.errorMessageEmail = '';
            this.loginForm.email = val;
            this.errorFlag = true;
            this.isSubmit();
            return true;
          }else{
            this.errorFlag = false;
            this.errorMessageEmail = this.langConfig.login[this.langConfig.curLang]['EMAIL_FORMAT'];
            this.isSubmit();
            return false;
          }
        }else if(type == 'pwd') {
          let _reg = this.pwdRxp;
          
          if(_reg.test(val)){
            this.errorMessagePwd = '';
            this.loginForm.password = val;
            this.errorFlag = true;
            this.isSubmit();
            return true;
          }else{
            this.errorFlag = false;
            this.errorMessagePwd = this.langConfig.login[this.langConfig.curLang]['LEAST_DIGITS'];
            this.isSubmit();
            return false;
          }
        }else if(type == 'pwd2') {
          let _reg = this.pwdRxp;
          
          if(_reg.test(val)){
            this.errorMessagePwd2 = '';
            this.loginForm.password2 = val;
            if(this.loginForm.password === this.loginForm.password2){
              this.errorFlag = true;
              this.isSubmit();
            }else{
              this.errorFlag = false;
              this.errorMessagePwd2 = this.langConfig.login[this.langConfig.curLang]['INCONSISTENT'];
              this.isSubmit();
            }
            return true;
          }else{
            this.errorFlag = false;
            this.errorMessagePwd2 = this.langConfig.login[this.langConfig.curLang]['LEAST_DIGITS'];
            this.isSubmit();
            return false;
          }
        }else if(type == 'captcha'){
          this.loginForm.captcha = val;
          this.isSubmit();
        }
      },

      // 提交
      onSubmit(val){
        this.disabled = true;

        let _step = this.step[this.step.length-1];

        if(_step == 1 || _step == 4){ // 登录, 激活登录
          this.onLoginSubmit(val);
        }else if(_step == 2 || _step == 9){ // 注册/账户未激活重新发送
          this.onSignUpSubmit(val);
        }else if(_step == 5){ // 忘记密码
          this.onForgotPwdSubmit(val);
        }else if(_step == 7){ // 重设密码
          this.onResetPwdSubmit(val);
        }
      },

      // 邮箱登录
      onLoginSubmit(val){
        let _val = val;
        let param = {
          email: _val.email,
          pwd: _val.password,
          captcha: _val.captcha,
          //reToken: this.loginForm.validateCode,
          
        }
        
        getEmailLogin(param).then((res) => {
          this.disabled = false;

          let _res = res;
          console.log('登录', _res)
          if(_res.state != 200){
            if(_res.state == 400){
              if(_res.error == 1007){ // 账户未激活
                this.step.push(9);
                this.loginForm.captcha = '';
                this.reloadCodeImgFn();
                this.isSubmit();
                return;
              }
            }
            Toast(_res.msg);
            //this.resetCode();
            this.reloadCodeImgFn();
            return;
          }

          let _userInfo = this.common.jsonParse(_res.data);
          _userInfo.nickname = escape(_userInfo.nickname).replace(/%/g, '-');
          this.common.setCookie('userInfo', JSON.stringify(_userInfo));
          this.login.loginInfoShow = true;
          this.loginPopClose();
          if(this.common.GetQueryString('signup') != 'undefined'){// 注册激活刷新页面
            location.href = location.href.split('?')[0];
            location.reload();
            return;
          }
          location.reload();

        }).catch((res) => {
          console.error(res)
        })
      },

      // 邮箱注册/重新发送
      onSignUpSubmit(val){
        let _val = val;
        let _step = this.step[this.step.length-1];
        let param = {
          email: _step == 9 ? this.loginForm.email : _val.email,
          pwd: _step == 9 ? this.loginForm.password : _val.password,
          captcha: _val.captcha,
          //reToken: this.loginForm.validateCode,
          url: location.href.split('?')[0] + '?signup=1'
        }
        
        getEmailSignUp(param).then((res) => {
          this.disabled = false;
          let _res = res;
          if(_res.state != 200){
            //this.resetCode();
            this.reloadCodeImgFn();
            Toast(_res.msg);
            return;
          }

          if(_step == 9){
            this.step.push(10);
          }else{
            this.step.push(3);
          }
          

        }).catch((res) => {
          console.error(res)
        })
      },

      // 忘记密码
      onForgotPwdSubmit(val){
        let _val = val;
        let param = {
          email: _val.email,
          captcha: _val.captcha,
          //reToken: this.loginForm.validateCode,
          url: location.href.split('?')[0]
        }
        
        getForgotPwd(param).then((res) => {
          this.disabled = false;
          let _res = res;
          if(_res.state != 200){
            //this.resetCode();
            this.reloadCodeImgFn();
            Toast(_res.msg);
            return;
          }

          this.step.push(6);
          

        }).catch((res) => {
          console.error(res)
        })
      },

      // 重设密码
      onResetPwdSubmit(val){
        let _val = val;
        let param = {
          resetToken: this.resetToken,
          pwd: _val.password,
          //reToken: this.loginForm.validateCode,
          url: location.href.split('?')[0]
        }
        
        getResetPwd(param).then((res) => {
          this.disabled = false;
          let _res = res;
          if(_res.state != 200){
            //this.resetCode();
            this.reloadCodeImgFn();
            Toast(_res.msg);
            return;
          }

          this.step.push(8);
          // this.loginPopClose();
          // if(this.common.GetQueryString('resetToken') != 'undefined'){// 刷新页面
          //   location.href = location.href.split('?')[0];
          // }
          

        }).catch((res) => {
          console.error(res)
        })
      },

      // 提交按钮是否可用
      isSubmit(){
        if(this.step[this.step.length - 1] == 5){ // 忘记密码
          //if(this.loginForm.email != '' && this.loginForm.validateCode != '' && this.errorFlag){
          if(this.loginForm.email != '' && this.errorMessageEmail == '' && this.loginForm.captcha != ''){
            this.disabled = false;
          }else{
            this.disabled = true;
          }
          return;
        }

        if(this.step[this.step.length - 1] == 7){ // 重设密码
          //if(this.loginForm.password != '' && this.loginForm.password2 != '' && this.loginForm.validateCode != '' && (this.loginForm.password === this.loginForm.password2) && this.errorFlag){
          if(this.loginForm.password != '' && this.loginForm.password2 != '' && (this.loginForm.password === this.loginForm.password2) && this.errorMessageEmail == '' && this.errorMessagePwd == '' && this.errorMessagePwd2 == ''){
            this.disabled = false;
          }else{
            this.disabled = true;
          }
          return;
        }

        if(this.step[this.step.length - 1] == 9){ // 账户未激活
          if(this.loginForm.captcha != ''){
            this.disabled = false;
          }else{
            this.disabled = true;
          }
          return;
        }
        
        //if(this.loginForm.email != '' && this.loginForm.password != '' && this.loginForm.validateCode != '' && this.errorFlag){
        if(this.loginForm.email != '' && this.loginForm.password != '' && this.errorMessageEmail == '' && this.errorMessagePwd == '' && this.loginForm.captcha != ''){
          this.disabled = false;
        }else{
          this.disabled = true;
        }
      },

      // 清空输入框
      clearInput(){
        this.errorMessageEmail = '';
        this.errorMessagePwd = '';
        this.loginForm.email = '';
        this.loginForm.password = '';
        this.loginForm.validateCode = '';
        this.loginForm.captcha = '';
        this.disabled = true;
        this.reCaptchaFlag = false;
      },

      // 重置人机认证
      resetCode(){
        this.loginForm.validateCode = '';
        this.reCaptchaFlag = false;
        setTimeout(()=>{
          this.reCaptchaFlag = true;
        }, 50);
      },

      // 跳转注册
      toSingUp(){
        this.clearInput();
        this.$refs.form.resetValidation();
        //this.resetCode();
        this.reloadCodeImgFn();
        this.step.push(2);
        //this.$refs.signForm.resetFields();
      },

      // 跳转登录
      toLogIn(){
        this.clearInput();
        this.$refs.form.resetValidation();
        //this.resetCode();
        this.reloadCodeImgFn();
        this.step.push(1);
      },

      // 跳转忘记密码
      toForgot(){
        this.clearInput();
        this.$refs.form.resetValidation();
        //this.resetCode();
        this.reloadCodeImgFn();
        this.step.push(5);
      },

      // 激活失败跳转登录
      toLogInFail(){
        this.step = [];
        this.step.push(1);
      },

      // 重设密码激活失败跳转找回密码
      toForgotFail(){
        this.step.push(5);
      },

      // 回跳弹窗
      backPop(){
        let param = {
          userToken: ''
        };

        if(this.common.GetQueryString('token') != 'undefined'){// 注册激活
          let _token = this.common.GetQueryString('token');
          this.token = _token;
          param.userToken = _token;
        }

        if(this.common.GetQueryString('userToken') != 'undefined'){// 第三方
          let _token = this.common.GetQueryString('userToken');
          this.token = _token;
          param.userToken = _token;
        }

        let _isLoginPm = this.common.isLogin(param); // 是否登录Promise
        _isLoginPm.then((res)=>{ // res返回true,false
          let _isLogin = res;
          //console.log('是否登录',_isLogin)

          if(_isLogin){// 已登录
            //this.login.loginInfoShow = true;
            //this.$emit('onChangePop', this.login);
            if(this.common.GetQueryString('token') != 'undefined'){
              location.href = location.href.split('?')[0];
              location.reload();
            }

            if(this.common.GetQueryString('userToken') != 'undefined'){
              location.href = location.href.split('?')[0];
              location.reload();
            }

          }else{// 未登录
            if(this.common.GetQueryString('signup') != 'undefined'){// 注册激活
              this.login.loginInfoShow = false;
              this.show = true;

              if(this.common.GetQueryString('type') == 1){ // 激活失败
                this.step.push(11);
              }else{
                this.step.push(4);
              }

              return;
            }

            if(this.common.GetQueryString('type') == 2){ // 重设密码激活失败
              this.login.loginInfoShow = false;
              this.show = true;
              this.step.push(12);
              return;
            }

            if(this.common.GetQueryString('resetToken') != 'undefined'){// 重设密码
              this.login.loginInfoShow = false;
              this.show = true;
              this.resetToken = this.common.GetQueryString('resetToken');
              
              this.step.push(7);
            }
          }
        })
      },

      // 图片验证码返回地址
      codeImgFn(){
        const protocol = 'https://';
        const host = window.location.host;
        let hostname = window.location.hostname;
        let _lang = 'en';

        if(hostname.indexOf('en') > -1){
          _lang = 'en';
        }
        if(hostname.indexOf('kr') > -1){
          _lang = 'kr';
        }
        if(hostname.indexOf('th') > -1){
          _lang = 'th';
        }
        if(hostname.indexOf('vn') > -1){
          _lang = 'vn';
        }

        let _env = protocol + _lang;

        if(host.indexOf('dev') != -1 || host.indexOf('localhost') != -1 || host.indexOf('127.0.0.1') != -1){
          _env = protocol + _lang + '.dev';
        }
        if(host.indexOf('test') != -1){
          _env = protocol + _lang + '.test';
        }
        if(host.indexOf('staging') != -1){
          _env = protocol + _lang + '.staging';
        }
        if(host.indexOf('kqbd') != -1){
          _env = protocol + 'kqbd';
        }

        let _imgUrl = _env + '.upgoal.com/api/user/version/1_0/code?timestamp=' + new Date().getTime();

        return _imgUrl;
      },

      // 重新加载验证图
      reloadCodeImgFn(){
        this.captchaSrc = this.codeImgFn();
      },


      //获取屏幕宽度
      handleResize() {
        if(typeof window!='undefined'){
          this.screenWidth = window.innerWidth;
        }
      },

      SignUpBtn(e){
        if(e.target.id === 'SignUp'){
          this.toSingUp()
        }
      },
      LogInBtn(e){
        if(e.target.id === 'LogIn'){
          this.toLogIn()
        }
      }
    },

    created() {
      if(typeof(window) != 'undefined'){
        window.addEventListener('resize', this.handleResize);
      }
    },

    watch: {
      loginShow:{
        immediate:true,
        handler(val){
          this.show = val;
        }
      }
    }
  }
</script>

<style lang="less">
@import '~@/style/login/login.less';
</style>


// WEBPACK FOOTER //
// ./src/components/login.vue